const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

export type ApiError = { ok: false; error: string; status: number };

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);

  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  if (method !== 'GET' && method !== 'HEAD') {
    const csrf = readCookie('bbc_csrf');
    if (csrf) headers.set('X-CSRF-Token', csrf);
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers,
    credentials: 'include',
  });

  const text = await res.text();
  let data: unknown;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { ok: false, error: 'Invalid response from server' };
  }

  if (!res.ok) {
    const err: ApiError = {
      ok: false,
      error:
        (data && typeof data === 'object' && 'error' in data
          ? String((data as Record<string, unknown>).error)
          : `Request failed (${res.status})`),
      status: res.status,
    };
    throw err;
  }

  return data as T;
}
